let CameraHandler = function (___settings, ___handlers) {
  const THREE = require('../../../../externals/three'),
        GLOBAL_UTILS = require('../../../../shared/util/GlobalUtils'),
        CameraHandlerInterface = require('../../../interfaces/handlers/CameraHandlerInterface'),
        _settings = ___settings.settings,
        _container = ___settings.container,
        _handlers = ___handlers;

  let that,
      _camera, _orbitControls,
      _active =  true;

  class CameraHandler extends CameraHandlerInterface {

    constructor() {
      super();
      that = this;

      _camera = new THREE.PerspectiveCamera(_settings.getSetting('fov'), _container.offsetWidth / _container.offsetHeight, _settings.getSetting('near'), _settings.getSetting('far'));
      _camera.position.set(5, 5, 5);
      _camera.up.set(0, 0, 1);
      _handlers.threeDManager.helpers.addSceneObject(_camera);

      let proxy = new (require('../../../helpers/OrbitControlsProxyStandardImplementation'))(_handlers);
      _orbitControls = new THREE.OrbitControls(_camera, proxy);
      proxy.initialize();

      _orbitControls.target.set(0, 0, 0);
    }

    ////////////
    ////////////
    //
    // CameraHandler API
    //
    ////////////
    ////////////
    
    /** @inheritdoc */
    pause() {
      _active = false;
      _orbitControls.enabled = false;
      _orbitControls.resetState();
    }

    /** @inheritdoc */
    resume() { 
      _active = true;
      _orbitControls.enabled = true;
    }

    /** @inheritdoc */
    destroy() { 
      // destroy the camera handler
    }



    
    /** @inheritdoc */
    setPosition(position) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    resetPosition() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getPosition() {
      return GLOBAL_UTILS.deepCopy(_orbitControls.object.position);
    }




    /** @inheritdoc */
    setTarget(target) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    resetTarget() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getTarget() {
      return GLOBAL_UTILS.deepCopy(_orbitControls.target);
    }




    /** @inheritdoc */
    setPositionAndTarget(position, target, options) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    resetPositionAndTarget(options) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getPositionAndTarget() {
      return {
        position: that.getPosition(),
        target: that.getTarget()
      };
    }




    /** @inheritdoc */
    zoomExtents(options, bb) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    setCameraPath(positions, targets, options) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }




    /** @inheritdoc */
    getCamera() {
      return _camera;
    }

    /** @inheritdoc */
    isCameraMoving() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    updateOrbitControls() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    adjustToBoundingSphere(bs) {
      _camera.far = 100.0 * bs.radius;
      _camera.near = 0.01 * bs.radius;
      _camera.updateProjectionMatrix();    
    }

    /** @inheritdoc */
    onResize(width, height) {
      _camera.aspect = width / height;
      _camera.setViewOffset(width, height, 0, 0, width, height);
      _camera.updateProjectionMatrix();
    }
  }

  return new CameraHandler();
};

module.exports = CameraHandler;
